import { useEffect, useState } from 'react';

export const FIELD_OPTIONS_CHANGED_EVENT = 'field-options:changed';

export const FIELD_OPTION_DEFAULTS = {
  moss_pole_type: [
    { value: 'Sphagnum', label: 'Sphagnum' },
    { value: 'Coco Coir', label: 'Coco Coir' },
    { value: 'Hybrid', label: 'Hybrid' },
    { value: 'DIY', label: 'DIY' },
  ],
  repot_pot_type: [
    { value: 'Nursery', label: 'Nursery' },
    { value: 'Terracotta', label: 'Terracotta' },
    { value: 'Ceramic', label: 'Ceramic' },
    { value: 'Plastic', label: 'Plastic' },
    { value: 'Self-watering', label: 'Self-watering' },
  ],
  repot_root_condition: [
    { value: 'Healthy', label: 'Healthy' },
    { value: 'Root Bound', label: 'Root Bound' },
    { value: 'Rot', label: 'Rot' },
    { value: 'Sparse', label: 'Sparse' },
  ],
  fertilize_method: [
    { value: 'Top Water', label: 'Top Water' },
    { value: 'Bottom Water', label: 'Bottom Water' },
    { value: 'Foliar Spray', label: 'Foliar Spray' },
    { value: 'Reservoir', label: 'Reservoir' },
    { value: 'Slow Release', label: 'Slow Release' },
  ],
  treatment_category: [
    { value: 'pest', label: 'Pest' },
    { value: 'fungal', label: 'Fungal' },
    { value: 'rot', label: 'Rot' },
    { value: 'bacterial', label: 'Bacterial' },
    { value: 'other', label: 'Other' },
  ],
  treatment_method: [
    { value: 'Spray', label: 'Spray' },
    { value: 'Soil Drench', label: 'Soil Drench' },
    { value: 'Manual Removal', label: 'Manual Removal' },
    { value: 'Isolation', label: 'Isolation' },
    { value: 'Systemic', label: 'Systemic' },
  ],
};

export const FIELD_OPTION_GROUP_LABELS = {
  moss_pole_type: 'Moss Pole',
  repot_pot_type: 'Repot Pot Type',
  repot_root_condition: 'Repot Root Condition',
  fertilize_method: 'Fertilize Method',
  treatment_category: 'Treatment Category',
  treatment_method: 'Treatment Method',
  prop_hormone: 'Rooting Hormone',
  prop_enclosure: 'Propagation Enclosure',
  loss_reason: 'Loss / Failure Reason',
};

export function normalizeFieldOption(option) {
  return {
    ...option,
    value: option.value ?? option.name ?? '',
    label: option.label ?? option.value ?? option.name ?? '',
  };
}

export function fieldOptionList(options, groupKey) {
  const list = options?.[groupKey]?.length
    ? options[groupKey]
    : FIELD_OPTION_DEFAULTS[groupKey] || [];
  return list.map(normalizeFieldOption).filter(option => option.value);
}

export function notifyFieldOptionsChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(FIELD_OPTIONS_CHANGED_EVENT));
  }
}

export async function fetchFieldOptions() {
  const response = await fetch('/field-options');
  if (!response.ok) throw new Error('Failed to load field options');
  return response.json();
}

export function useFieldOptions() {
  const [options, setOptions] = useState(FIELD_OPTION_DEFAULTS);

  useEffect(() => {
    let active = true;
    const load = () => {
      fetchFieldOptions()
        .then(data => {
          if (active) setOptions(prev => ({ ...prev, ...data }));
        })
        .catch(() => {});
    };

    load();
    window.addEventListener(FIELD_OPTIONS_CHANGED_EVENT, load);
    return () => {
      active = false;
      window.removeEventListener(FIELD_OPTIONS_CHANGED_EVENT, load);
    };
  }, []);

  return options;
}
